"use strict";
/*
 * Created on 10. 1. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Exported promotion performance converter.
 *
 * @author Radek Beran
 */


var ExportedPromotionPerformanceConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ExportedPromotionPerformanceConverter, _DataObjectConverter_);

  function ExportedPromotionPerformanceConverter() {
    _classCallCheck(this, ExportedPromotionPerformanceConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ExportedPromotionPerformanceConverter).apply(this, arguments));
  }

  return ExportedPromotionPerformanceConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ExportedPromotionPerformanceConverter = ExportedPromotionPerformanceConverter;